import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DashboardService, UserResponse } from '@app/api/dmc';
import { FormApiService } from '@app/core/services/form-api.service';
import { AlertService } from '@app/core/services/alert.service';
import { ModalService } from '@app/core/services/modal.service';
import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { LabelDirective } from '@shared/components/input/label/label.directive';
import { InputDirective } from '@shared/components/input/input/input.directive';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { HasUnsavedChanges } from '@app/core/guards/unsaved-changes.guard';

@Component({
  selector: 'app-dashboard-remove-failed-automation',
  imports: [
    ReactiveFormsModule,
    InputGroupComponent,
    LabelDirective,
    InputDirective,
    TranslatePipe,
  ],
  templateUrl: './dashboard-remove-failed-automation.component.html',
  styleUrl: './dashboard-remove-failed-automation.component.css'
})
export class DashboardRemoveFailedAutomationComponent implements OnInit, HasUnsavedChanges {
  protected readonly UserResponse = UserResponse;

  public hasUnsavedChanges(): boolean {
    return this.form.dirty;
  }

  public form: FormGroup = new FormGroup({
    response: new FormControl(null, Validators.required),
  });

  public elements: any[] = [];

  constructor(
    private readonly dashboardService: DashboardService,
    private readonly formApiService: FormApiService,
    private readonly alertService: AlertService,
    private readonly modalService: ModalService,
    private readonly translateService: TranslateService,
  ) {}

  public ngOnInit(): void {
    const message = this.translateService.instant(
      'dashboard.remove.failedautomation.info',
      { count: this.elements.length }
    );
    this.alertService.open('modal', 'info', message);
  }

  public submit(): void {
    if (this.form.value.response === UserResponse.Rejected) {
      this.modalService.close();
      return;
    }

    const ids = this.elements.map((e: any) => e.rsmTriggerInstanceId).filter(Boolean);
    if (ids.length === 0) {
      return;
    }

    this.formApiService.submit(this.form,
      () => this.dashboardService.dashboardHandleFailedAutomationsPost({ rsmTriggerInstanceIds: ids }),
      {
        closeModal: true,
        successMessage: 'dashboard.remove.failedautomation.success',
      }
    );
  }
}
